var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLike = function SvgIconLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.13em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 26 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.95,
    d: "M2.713 3.409a5.85 5.85 0 0 0 0 8.273l9.987 9.987 9.987-9.987a5.85 5.85 0 0 0-8.273-8.273L12.7 5.122 10.987 3.41a5.85 5.85 0 0 0-8.274 0"
  })));
};
export default SvgIconLike;